module.exports = __webpack_public_path__ + "static/media/fokus.4e4f981f.png";